export const delay = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms));

/**
 * Await the usual time it takes for a record to get indexed if you need to
 * fetch that data immediately after editing.
 */
export const delayForIndexing = (ms = 2000) => delay(ms);
